// 내 계정 — 정보 확인·이메일 인증 재발송·회원 탈퇴
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@taplink/web-shared";
import { ApiError } from "@taplink/web-shared";
import { useAuth } from "@taplink/web-shared";

export function AccountPage() {
  const { me, logout } = useAuth();
  const navigate = useNavigate();
  const [notice, setNotice] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  if (!me) return null;

  const isEmailAccount = me.loginId.includes("@");

  /**
   * 인증 메일 재발송.
   *
   * ⚠️ 누르면 **곧바로 메일이 나갔다.** 밖으로 나가는 동작은 되돌릴 수 없고,
   *    여러 번 누르면 같은 메일이 여러 통 간다(받는 사람에게는 스팸으로 보이고
   *    발신 도메인 평판도 깎인다). 무엇이 일어나는지 먼저 알리고 확인을 받는다 —
   *    회원 탈퇴와 같은 방식이다.
   */
  const resend = async () => {
    const confirmed = window.confirm(
      `${me.loginId} 로 인증 메일을 보냅니다.\n\n` +
        "· 메일의 링크를 열면 인증이 끝납니다\n" +
        "· 이전에 받은 인증 링크는 더 이상 쓸 수 없게 됩니다\n" +
        "· 몇 분 안에 오지 않으면 스팸함을 확인해 주세요",
    );
    if (!confirmed) return;

    setError(null);
    try {
      setNotice((await authApi.resendVerification()).message);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "발송에 실패했습니다.");
    }
  };

  const withdraw = async () => {
    const confirmed = window.confirm(
      "정말 탈퇴하시겠습니까?\n\n" +
        "· 계정 정보가 파기됩니다\n" +
        "· 생성한 링크가 모두 비활성화되어 접속이 차단됩니다\n" +
        "· 이 작업은 되돌릴 수 없습니다",
    );
    if (!confirmed) return;

    try {
      await authApi.withdraw();
      logout();
      navigate("/login", { replace: true });
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "탈퇴 처리에 실패했습니다.");
    }
  };

  return (
    <section className="panel">
      <h2>내 계정</h2>

      {notice && <div className="alert alert-success" role="status">{notice}</div>}
      {error && <div className="alert alert-error" role="alert">{error}</div>}

      <dl className="detail-list">
        <dt>아이디</dt>
        <dd>{me.loginId}</dd>
        {me.displayName && (
          <>
            <dt>이름</dt>
            <dd>{me.displayName}</dd>
          </>
        )}
        <dt>요금제</dt>
        <dd><span className="badge">{me.planType}</span></dd>
        <dt>상태</dt>
        <dd><span className="badge">{me.status}</span></dd>
        <dt>마지막 로그인</dt>
        <dd>{me.lastLoginAt ? new Date(me.lastLoginAt).toLocaleString("ko-KR") : "-"}</dd>
      </dl>

      {isEmailAccount && (
        <p className="hint">
          이메일 인증이 필요하면{" "}
          <button type="button" className="btn-link" onClick={() => void resend()}>
            인증 메일 다시 받기
          </button>
        </p>
      )}

      <h2>회원 탈퇴</h2>
      <p className="hint">
        탈퇴 시 개인정보가 파기되며, 생성한 링크는 모두 비활성화됩니다. 되돌릴 수 없습니다.
      </p>
      {/* 되돌릴 수 없는 동작이라 **채운** 위험 버튼을 쓴다 — 목록 안의 삭제(윤곽선)와
          무게가 달라야 한다. 인라인 width:auto 는 지웠다: 이제 버튼 기본 폭이 auto 다. */}
      <button type="button" className="btn-danger" onClick={() => void withdraw()}>
        회원 탈퇴
      </button>
    </section>
  );
}
